// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationScheduledHomeDeliveryPath = 'M69 63v17h5V7H27v5.298c9.654 1.66 17 10.073 17 20.202 0 10.129-7.346 18.542-17 20.202V80h5V63h37zM20 52.702V80H9v13H2v7h96v-7h-6V80H81V0H20v12.298C10.345 13.958 3 22.37 3 32.5c0 10.129 7.345 18.542 17 20.202zM69 93v-6h16v6H69zm-37-6v6H16v-6h16zm0-51.5l-5 5-7-7V23h7v7.6l5 4.9zm32.5 12a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM62 93H39V70h8v6h7v-6h8v23zm-20-9h7v7h-7v-7zM23.5 19C16.044 19 10 25.044 10 32.5S16.044 46 23.5 46 37 39.956 37 32.5c-.054-7.433-6.067-13.445-13.5-13.5z';
var IllustrationScheduledHomeDelivery = baseIllustration('IllustrationScheduledHomeDelivery', {
  getPath: () => IllustrationScheduledHomeDeliveryPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationScheduledHomeDelivery;
//# sourceMappingURL=index.js.map